import {PersistService} from "./persistService";

export var EventService = (function () {
    var eventStackMaxLength = 2000;
    var url = process.env.REACT_APP_API_ENDPOINT + "/rest/proeve";
    var events = [];
    loadEventsFromLocalStorage();
    var currentParti = {proeveId:null, partiId:null, klasse: null, hovedklassePartiId:null, token:null};
    var timeoutPromise = null;


    var EVENT = {
        IKKE_MOEDT_SATT: "proeve.kritikk.event.IkkeMoedtSatt",
        IKKE_MOEDT_FJERNET: "proeve.kritikk.event.IkkeMoedtFjernet",
        CACIOB_SATT: "proeve.kritikk.event.lydighet.CaciobSatt",
        CACIOB_FJERNET: "proeve.kritikk.event.lydighet.CaciobFjernet",
        RESERVE_CACIOB_SATT: "proeve.kritikk.event.lydighet.ReserveCaciobSatt",
        RESERVE_CACIOB_FJERNET: "proeve.kritikk.event.lydighet.ReserveCaciobFjernet",
        OEVELSE_DOMMER_KOMMENTAR_ENDRET: "proeve.kritikk.event.lydighet.OevelseDommerKommentarEndret",
        OEVELSE_POENG_OPPNAADD_ENDRET: "proeve.kritikk.event.lydighet.OevelsePoengOppnaaddEndret",
        GULTKORT_SATT: "proeve.kritikk.event.lydighet.GultKortSatt",
        GULTKORT_FJERNET: "proeve.kritikk.event.lydighet.GultKortFjernet",
        ROEDTKORT_SATT: "proeve.kritikk.event.lydighet.RoedtKortSatt",
        ROEDTKORT_FJERNET: "proeve.kritikk.event.lydighet.RoedtKortFjernet",
        TITTEL_ENDRET: "proeve.kritikk.event.TittelEndret",
        PLASSERING_ENDRET: "proeve.kritikk.event.PlasseringEndret",
        PREMIEGRAD_ENDRET: "proeve.kritikk.event.PremiegradEndret",
    }
    
    function sendIkkeMoedtEvent(lnr, katalogNr, satt) {
        var e = {proeveId: currentParti.proeveId, partiId: currentParti.hovedklassePartiId, lnr: lnr, katalognr: katalogNr};
        if (satt) addEvent(EVENT.IKKE_MOEDT_SATT, e);
        else addEvent(EVENT.IKKE_MOEDT_FJERNET, e);
    }


    function sendCaciobEvent(lnr, katalogNr, satt) {
        var e = {proeveId: currentParti.proeveId, partiId: currentParti.hovedklassePartiId, lnr: lnr, katalognr: katalogNr};
        if (satt) addEvent(EVENT.CACIOB_SATT, e);
        else addEvent(EVENT.CACIOB_FJERNET, e);
    }

    function sendReserveCaciobEvent(lnr, katalogNr, satt) {
        var e = {proeveId: currentParti.proeveId, partiId: currentParti.hovedklassePartiId, lnr: lnr, katalognr: katalogNr};
        if (satt) addEvent(EVENT.RESERVE_CACIOB_SATT, e);
        else addEvent(EVENT.RESERVE_CACIOB_FJERNET, e);
    }

    function sendGultKortEvent(lnr, katalogNr, satt) {
        var e = {proeveId: currentParti.proeveId, partiId: currentParti.hovedklassePartiId, lnr: lnr, katalognr: katalogNr};
        if (satt) addEvent(EVENT.GULTKORT_SATT, e);
        else addEvent(EVENT.GULTKORT_FJERNET, e);
    }

    function sendRoedtKortEvent(lnr, katalogNr, satt) {
        var e = {proeveId: currentParti.proeveId, partiId: currentParti.hovedklassePartiId, lnr: lnr, katalognr: katalogNr};
        if (satt) addEvent(EVENT.ROEDTKORT_SATT, e);
        else addEvent(EVENT.ROEDTKORT_FJERNET, e);
    }

    function sendOevelsePoengEndretEvent(lnr, katalogNr, oevelseNr, navn, poeng, koeffisient) {

        var e = {proeveId: currentParti.proeveId, partiId: currentParti.hovedklassePartiId, lnr: lnr, katalognr: katalogNr,
            klasse: currentParti.klasse, oevelseNr: oevelseNr, navn: navn, koeffisient: koeffisient};
        if (poeng !== null && poeng !== '') {

            e.poengOppnaadd = poeng;
        }
        addEvent(EVENT.OEVELSE_POENG_OPPNAADD_ENDRET, e);
    }

    function sendPlasseringEndretEvent(lnr, katalogNr, plassering) {
        var e = {proeveId: currentParti.proeveId, partiId: currentParti.hovedklassePartiId, lnr: lnr, katalognr: katalogNr, plassering: plassering};
        addEvent(EVENT.PLASSERING_ENDRET, e);
    }

    function sendPremiegradEndretEvent(lnr, katalogNr, premiegrad) {
        var e = {proeveId: currentParti.proeveId, partiId: currentParti.hovedklassePartiId, lnr: lnr, katalognr: katalogNr, premiegrad: premiegrad};
        addEvent(EVENT.PREMIEGRAD_ENDRET, e);
    }

    function sendTittelEndretEvent(lnr, katalogNr, tittelId) {
        var e = {proeveId: currentParti.proeveId, partiId: currentParti.hovedklassePartiId, lnr: lnr, katalognr: katalogNr, tittelId: tittelId};
        addEvent(EVENT.TITTEL_ENDRET, e);
    }


    function sendOevelseDommerKommentarEndretEvent(lnr, katalogNr, oevelseNr, navn, kommentar, koeffisient) {
        var e = {proeveId: currentParti.proeveId, partiId: currentParti.hovedklassePartiId, lnr: lnr, katalognr: katalogNr,
            klasse: currentParti.klasse, oevelseNr: oevelseNr, navn: navn, kommentar: kommentar, koeffisient: koeffisient};
        //var e = {proeveId: currentParti.proeveId, partiId: currentParti.partiId, lnr: lnr, katalognr: katalogNr};
        addEvent(EVENT.OEVELSE_DOMMER_KOMMENTAR_ENDRET, e);
    }

    //private methods



    function addEvent(type, e) {
        if (!type) {
            console.log("Event must have a type.");
            return;
        }
        e["eventId"] = guid();
        e["timestamp"] = new Date().getTime();
        e["@class"] = type;
        //console.log(e);
        events.push(e);
        pushEventToBackupStack(e);
        saveEventsToLocalStorage();

        if (timeoutPromise !== null) {
            clearTimeout(timeoutPromise);
        }
        timeoutPromise = setTimeout(function() {sendEventsToServer()}, 1000);
    }

    function resendEvents() {
        if (timeoutPromise !== null) {
            clearTimeout(timeoutPromise);
        }
        sendEventsToServer();
    }

    function pushEventToBackupStack(e) {
        var stack = [];
        var s = window.localStorage.getItem('dkk-proeve-lydighet-parti-events-' + process.env.REACT_APP_ENV + '-backup');
        if (s) {
            stack = JSON.parse(s);
        }
        stack.push(e);
        if (stack.length > eventStackMaxLength) {
            stack.shift();
        }
        window.localStorage.setItem('dkk-proeve-lydighet-parti-events-' + process.env.REACT_APP_ENV + '-backup', JSON.stringify(stack));
    }




    function saveEventsToLocalStorage() {
        //console.log("Size events" +  events.length);
        window.localStorage.removeItem('dkk-proeve-lydighet-parti-events-' + process.env.REACT_APP_ENV);
        window.localStorage.setItem('dkk-proeve-lydighet-parti-events-' +  process.env.REACT_APP_ENV, JSON.stringify(events));
        window.localStorage.setItem('dkk-proeve-lydighet-parti-' + process.env.REACT_APP_ENV + '-id', PersistService.getId() + '-' + new Date().getTime());
        //$rootScope.unsynched = events.length;
    }

    function confirmEvent(eventId) {
        var i;
        for (i = events.length-1; i>=0; i--) {
            if (events[i].eventId === eventId) {
                events.splice(i, 1);
                break;
            }
        }
    }

    function guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }


    function setParti(proeveId, partiId, klasse, hovedklassePartiId, token) {
        currentParti.proeveId = proeveId;
        currentParti.partiId = partiId;
        currentParti.hovedklassePartiId = hovedklassePartiId;
        currentParti.klasse = klasse;
        currentParti.token = token;

    }

    function loadEventsFromLocalStorage() {
        var s = window.localStorage.getItem('dkk-proeve-lydighet-parti-events-' + process.env.REACT_APP_ENV);
        if (s) {
            events = JSON.parse(s);
        } else {
            events = [];
        }
    }

    function deleteEventsFromLocalStorage() {
        events = [];
        window.localStorage.removeItem('dkk-proeve-lydighet-parti-events-' + process.env.REACT_APP_ENV);
        //rootScope.unsynched = 0;
    }

    function postEventsToServer(eventsToBeSentToServer) {

        return new Promise((resolve, reject) => {
            window.fetch(url + '/' + currentParti.proeveId + '/parti/' + currentParti.partiId + '/events' ,{
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'parti-token': currentParti.token
                },
                body: JSON.stringify({
                    eventlist: {list: eventsToBeSentToServer}
                })
            })
                .then(_handleErrors)
                .then(resolve)
                .catch(reject);
        });
    }

    function sendEventsToServer() {
        if (events.length > 0) {
            postEventsToServer(events.slice())
                .then((response) => {
                        response.json()
                        .then((json) => {
                            for (var i = 0; i < json.eventIdList.length; i++) {
                                confirmEvent(json.eventIdList[i]);
                            }
                            saveEventsToLocalStorage();
                        });
                })
                .catch((err)=> {
                    console.log(err);
                });
        }
    }



    function getAntallEvents() {
        return events.length;
    }

    const _handleErrors = response => {
        if (!response.ok) {
            throw Error("Error");
        }
        return response;
    };


    return {
        loadEventsFromLocalStorage : loadEventsFromLocalStorage,
        setParti : setParti,
        deleteEventsFromLocalStorage : deleteEventsFromLocalStorage,
        sendIkkeMoedtEvent : sendIkkeMoedtEvent,
        sendOevelsePoengEndretEvent: sendOevelsePoengEndretEvent,
        sendOevelseDommerKommentarEndretEvent: sendOevelseDommerKommentarEndretEvent,
        sendGultKortEvent: sendGultKortEvent,
        sendRoedtKortEvent: sendRoedtKortEvent,
        sendCaciobEvent: sendCaciobEvent,
        sendReserveCaciobEvent: sendReserveCaciobEvent,
        getAntallEvents: getAntallEvents,
        resendEvents: resendEvents,
        sendPlasseringEndretEvent: sendPlasseringEndretEvent,
        sendPremiegradEndretEvent: sendPremiegradEndretEvent,
        sendTittelEndretEvent: sendTittelEndretEvent
    }
}());




// WEBPACK FOOTER //
// ./src/services/eventService.js